import axios from "axios";
import { useEffect,useState } from "react";
import { List,ListItem,ListItemText, ListItemButton, ListItemIcon, IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { CopyAll } from "@mui/icons-material";

function PeersAssigned(props)
{
    const [peerGroup,setPeerGroup]=useState({});
    //Load up the assigned peers to the selected peer group id
    // useEffect(()=>{
    //     axios({
    //         // Endpoint to send files
    //         url: process.env.REACT_APP_API_URL+'PeerGroup/'+props.selectedPeerGroupId,
    //         method: "GET",
    //         data:{ },
    //         headers: {
    //             // Add any auth token here
    //             //authorization: "your token comes here",
    //         },
    //     }).then((res) => {            
    //         setPeerGroup(res.data);
    //         console.log(res.data);
    //     }).catch((err) => {
    //         console.log(err)
    //     });
    // },[props.selectedPeerGroupId]
    // );
    
    function removeCompany(id)
    {
        //I'm going to run a test where I don't send in a name, I want to see what the service does with it
        //Todo - make the web call to update company

        //Change the peerCompanies array - I should trigger a reload of companies based on this getting dirty
        let company = props.peerCompanies.find((c)=>c.companyId===id);
        axios({
            // Endpoint to send files
            url: process.env.REACT_APP_API_URL+'PeerGroupCompany',
            method: "DELETE",
            data:{ 
                companyId:company.companyId,
                peerGroupId:props.selectedPeerGroupId
             },
        }).then((res) => {            
            //Add to all companies, remove from peer
            props.setPeerCompanies(props.peerCompanies.filter((c)=>c.companyId!==id));
            //I need to map and replace the matching company
            const updatedCompanies = props.allCompanies.map((c)=>c.companyId===company.companyId?company:c);
            props.setAllCompanies(updatedCompanies);
            
        }).catch((err) => {
            console.log(err)
        });
    }

    if(props.peerCompanies!=null && props.peerCompanies.length>0)
    {
    return(
        <>
            <h5>Assigned Companies</h5>
                <List>                  
                {/* Create a list of the assigned companies */}
                {props.peerCompanies.map((c)=>{
                    return (
                        <ListItem key={c.companyId}>
                            <IconButton size="small" onClick={()=>removeCompany(c.companyId)} color="error">
                                <DeleteIcon fontSize="small"></DeleteIcon>
                                </IconButton>
                            <ListItemText primary={c.companyName}></ListItemText>
                            
                        </ListItem>
                    )
                    })
                }
            </List>
        </>
    );
    }else{
        return (<><h5>Assigned Companies</h5></>);
    }
}

export default PeersAssigned;